<sw-modal
    @modal-close="onClose"
    :title="$tc('dvsn-form-builder-form.element.title')"
    class="dvsn-form-builder-form-detail-element"
>
    <sw-container class="card-base">

        <mt-banner
            class="type-info-alert"
            variant="info"
        >
            {{ currentTypeInfo }}
        </mt-banner>

        <sw-container
            columns="2fr 1fr"
            style="column-gap: 30px;"
        >
            <mt-text-field
                v-if="element"
                v-model="element.name"
                validation="required"
                required
                :helpText="$tc('dvsn-form-builder-form.element.card-base.name-help')"
                :label="$tc('dvsn-form-builder-form.element.card-base.name')"
            />

            <mt-select
                hide-clearable-button
                v-if="element"
                v-model="element.type"
                validation="required"
                required
                @update:model-value="selectType"
                type="select"
                :helpText="$tc('dvsn-form-builder-form.element.card-base.type-help')"
                :label="$tc('dvsn-form-builder-form.element.card-base.type')"
                :options="types"
            />
        </sw-container>

        <div class="group-header">
            {{ this.$t('dvsn-form-builder-form.element.options') }}
        </div>

        <sw-container
            columns="2fr 1fr"
            style="column-gap: 30px;"
        >
            <mt-text-field
                v-if="element"
                v-model="element.label"
                :disabled="!displayField('label')"
                :helpText="$tc('dvsn-form-builder-form.element.card-base.label-help')"
                :label="$tc('dvsn-form-builder-form.element.card-base.label')"
            />

            <mt-switch
                v-if="element"
                v-model="element.mandatory"
                :disabled="!displayField('mandatory')"
                bordered
                :helpText="$tc('dvsn-form-builder-form.element.card-base.mandatory-help')"
                :label="$tc('dvsn-form-builder-form.element.card-base.mandatory')"
            />
        </sw-container>

        <sw-container
            columns="1fr"
            style="column-gap: 30px;"
        >
            <mt-text-field
                v-if="element"
                v-model="element.placeholder"
                :disabled="!displayField('placeholder')"
                :helpText="$tc('dvsn-form-builder-form.element.card-base.placeholder-help')"
                :label="$tc('dvsn-form-builder-form.element.card-base.placeholder')"
            />

            <mt-text-field
                v-if="element"
                v-model="element.context"
                :disabled="!displayField('context')"
                :helpText="$tc('dvsn-form-builder-form.element.card-base.context-help')"
                :label="$tc('dvsn-form-builder-form.element.card-base.context')"
            />
        </sw-container>

        <div class="group-header">
            {{ this.$t('dvsn-form-builder-form.element.card-base.content') }}
        </div>

        <mt-textarea
            v-if="element && !displayField('selection')"
            v-model="element.options"
            :disabled="!displayField('options')"
        />

        <div
            v-if="element && displayField('selection')"
        >
            <sw-container
                columns="3fr 1fr"
                style="column-gap: 30px;"
                class="add-selection-container"
            >
                <mt-text-field
                    v-model="newSelection"
                    :placeholder="$t('dvsn-form-builder-form.element.card-base.selection.add-selection.value.placeholder')"
                />

                <mt-button
                    :disabled="isLoading"
                    variant="secondary"
                    size="default"
                    @click="onAddSelection()"
                >
                    {{ $t('dvsn-form-builder-form.element.card-base.selection.add-selection.button') }}
                </mt-button>
            </sw-container>

            <sw-data-grid
                v-if="hasSelection()"
                :columns="selectionColumns"
                :dataSource="selection"
                :allow-inline-edit="false"
                :show-settings="false"
                :show-selection="false"
                :compact-mode="true"
            >
                <template #column-value="{ item }">
                    {{ item.value }}
                </template>

                <template #actions="{ item }">
                    <sw-context-menu-item
                        variant="danger"
                        :disabled="false"
                        @click="onDeleteSelection(item)"
                    >
                        {{ $t('global.default.delete') }}
                    </sw-context-menu-item>
                </template>
            </sw-data-grid>

            <mt-banner
                v-if="!hasSelection()"
                variant="info"
                class="empty-selection"
            >
                {{ $t('dvsn-form-builder-form.element.card-base.selection.empty-selection-banner') }}
            </mt-banner>
        </div>
    </sw-container>

    <template #modal-footer>
        <mt-button
            variant="critical"
            size="default"
            @click="onCancel"
        >
            {{ $tc('dvsn-form-builder-form.element.actions.cancel') }}
        </mt-button>

        <mt-button
            variant="primary"
            size="default"
            @click="onSave"
        >
            {{ $tc('dvsn-form-builder-form.element.actions.save') }}
        </mt-button>
    </template>
</sw-modal>